/**
 * Loads the package list for a source instance, with error handling.
 *
 * SAP CPI IntegrationPackages rejects both $select and $inlinecount with
 * HTTP 501. The /api/:iid/transport/packages endpoint already normalizes
 * this to either a d.results object or a plain array.
 */

import { useEffect, useState, useCallback } from "react";
import { api } from "../../../utils/helpers";

export function usePackageList(sourceInstanceId) {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [reloadNonce, setReloadNonce] = useState(0);

  const reload = useCallback(() => setReloadNonce((n) => n + 1), []);

  useEffect(() => {
    if (!sourceInstanceId) {
      setPackages([]);
      return;
    }
    let mounted = true;
    setLoading(true);
    setError(null);
    api(`/api/${sourceInstanceId}/transport/packages`, { timeout: 45000 })
      .then((res) => {
        if (!mounted) return;
        const raw = Array.isArray(res?.d?.results) ? res.d.results : Array.isArray(res) ? res : [];
        const list = raw.map((p) => ({
          id: p.Id || p.Name,
          name: p.Name || p.Id,
          shortText: p.ShortText || "",
          version: p.Version || "",
          mod: p.ModifiedDate || p.ModifiedAt || null,
        })).filter((p) => p.id);
        setPackages(list);
        setLoading(false);
      })
      .catch((e) => {
        if (!mounted) return;
        setPackages([]);
        setError(e?.message || "Pakete konnten nicht geladen werden");
        setLoading(false);
      });
    return () => { mounted = false; };
  }, [sourceInstanceId, reloadNonce]);

  return { packages, loading, error, reload };
}
